import { render } from "./MediaOverlay.vue?vue&type=template&id=45ede038"
import script from "./MediaOverlay.vue?vue&type=script&lang=js"
export * from "./MediaOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__